import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Row,Col,Form} from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import LocationSearchInput from '../commons/helpers/googleLocationSearch';
import Toast from '../commons/helpers/toast';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import { ROUTE_REFRESH, SEARCH_TEXT_COUNT, DEFAULT_TIME_ZONE, PHONE_ISD_CODE, PHONE_ISD_NUM, ROUTE_SA_SETTINGS} from '../../configs/staticConfigs';
import {MSG_LOGO_FORMAT, MSG_FILE_FORMAT_ERROR, MSG_FILE_SIZE_ERROR, MSG_REQUIRED, MSG_TIMEZONE_DATA_ERROR, MSG_SERVER_DATA_FETCH_ERROR, MSG_PROFILE_UPDATE_SUCCESS, MSG_PROFILE_UPDATE_ERROR } from '../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_COMPANY_PROFILE, LBL_COMPANY_INFO, LBL_COMPANY_NAME, LBL_COMPANY_CONTACT_NUM, LBL_COMPANY_REG_NUM, LBL_COMPANY_EMAIL, LBL_WEBSITE, LBL_VAT_NUMBER, LBL_VAT_TAX, LBL_SAVE, LBL_TIME_ZONE, LBL_EMAIL_FUNCTIONALITY, LBL_SELECT_TIME_ZONE, LBL_LOCATION, LBL_LOC_GET_GOOGLE, LBL_TYPE_ADDRESS_GOOGLE, LBL_TYPE_A_LOCATION, LBL_VENUE_PROFILE, LBL_STREET_1, LBL_STREET_2,  LBL_CITY, LBL_STATE, LBL_COUNTRY, LBL_POST_CODE, LBL_SEARCHING, LBL_BACK_TO_SETTINGS } from '../../configs/labelConfigs';

import { getSAProfileDetailsAction, updateSAProfileDetailsAction } from '../../actions/superAdminActions'; 

import {clearAction, masterLocationListAction, timeZonesListAction} from '../../actions/commonActions';

import * as types from '../../actions'; 

import {validateEmail,imageExtension,fileSize,checkNumDotZero} from '../../utils/validation'; // decimalNumRegex

import {appendVenueLoc} from '../../utils/commonUtilities';
// import {setStorage} from '../../utils/browserStorage'; 

import {URL_IMG} from '../../configs/urlConfigs';
import * as gLoc from '../../configs/googleConfigs'; 
import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';
import getCroppedImg from '../commons/image-cropper/cropImage';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import ModalWindow from '../commons/helpers/modalWindow';

class SAProfileComponent extends Component {

    constructor(props){
        super(props)

        let profileId = 0;
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            profileId = userGroupData.profile_id;
        }

        this.state = {  
            companyInfo:{
                company_code: '',
                companyName:null,
                websiteUrl:'',
                companyContactNum:'',
                companyEmail:'',
                companyRegNum:'',
                vatNum:'',
                vatTax:0,
                logo:'',
                timeZone:'', 
                isEmailDisabled:false, 
                isClientEmailDisabled:false, 
                isCrewEmailDisabled:false, 
            },       
            companyAddress:{
                locationId:null,
                location:'',
                googleLocation:'',
                venue:'',
                streetOne:'',
                streetTwo:'',
                city:null,
                state:null,
                country:null,
                postcode:'',
                noLocationFound:false
            },  
            companyAddressPrev:{
                locationId:null,
                location:'',
                googleLocation:'',
                venue:'',
                streetOne:'',
                streetTwo:'',
                city:null,
                state:null,
                country:null,
                postcode:'',
            },   
            profileId:profileId, 
            userGroup:userGroup,
            imgUrl:null,   
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false, 
            defaultTimeZoneId: '',       
            formErrors:{
                companyName: '',
                companyContactNum:'',
                companyEmail:'',
                websiteUrl:'',
                vatTax:'',
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',
                contactNumber:'',
                emailAddress:'',
                timeZone:'',
            },          
            logoLabel:MSG_LOGO_FORMAT,
            isLogoValid:true,
            currentUrl:this.props.location,
            locGoogleCodes: {
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',   
            }, 
            timeZonesList: [],  
            resetGoogleLocation: 0,
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea:{},
            croppedAreaPixels:{},
            rotation:0,
            imgObj:null
        }
        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData   = this.saveFormData.bind(this);

        this.logoModalCropper = React.createRef(); 
        
    }

    disableSpace = (e)=>{
        if(e.which===32){
            e.preventDefault();
        }
    }

    renderTooltip(name,props) {
        return (
          <Tooltip id={name}  style={{
            opacity: 0.4,
          }} {...props} >
            {name}
          </Tooltip>
        );
    }

    onGetGoogleLocClick = (e) =>{
        // const instance = this._typeahead.getInstance() 
        // instance.clear();
        this.onGetGoogleLoc(e); 
    }
    
    onHandleChange = (e, dataType) =>{
        const {name}  = e.target;
        
        let value = '';
        if(e.target.type === "checkbox"){
            value = e.target.checked;
        }else{
            value   = e.target.type === "file" ? e.target.files[0] : e.target.value;  
        }

        let trimmedValue = '';
        if(e.target.type==="text" || e.target.type==="tel" || e.target.type==="email"){
            trimmedValue = value.trim(); 
        }
        let formErrors      = this.state.formErrors;
        let logoValid       = true;
        let logoError       = MSG_LOGO_FORMAT;               
        
        switch(name){
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError     = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if(!imageExtension(value.name)){
                    logoError     = MSG_FILE_FORMAT_ERROR;
                    logoValid = false;
                }      
                break; 
            case 'companyName':
                formErrors.companyName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;             
            case 'companyEmail':
                formErrors.companyEmail = trimmedValue.length >0 && validateEmail(trimmedValue) === false ? MSG_REQUIRED : ""; 
                break;  
            case 'websiteUrl':
                formErrors.websiteUrl = "";               
                break;
            case 'vatTax':
                formErrors.vatTax = ''; 
                if(!checkNumDotZero(value)) {
                    value = '';
                }
                else {
                    let t = value; 
                    value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
                }
                if(value==='') formErrors.vatTax = MSG_REQUIRED; 
                break;  
            case 'contactNumber':
                formErrors.contactNumber = ''; 
                // trimmedValue.length <=0  ? MSG_REQUIRED : ""
                break;        
            case 'city':
                formErrors.city = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;    
            case 'state':
                formErrors.state = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            case 'country':
                formErrors.country = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'postcode':
                formErrors.postcode = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'timeZone':
                formErrors.timeZone = (value.length <=0 || Number(value)===0) ? MSG_REQUIRED : ""; 
                break; 
            default :
            break;
        }

        let companyInfo      = this.state.companyInfo;
        let companyAddress   = this.state.companyAddress;
        
        if(dataType==='companyInfo'){
            companyInfo[name] = value;
        }else if(dataType==='addressInfo'){       
            companyAddress[name] = value;
        }
        
        if(e.target.type=== "file"){
            let imgUrl = '';
            let imgObj = null;
            if(imageExtension(e.target.files[0].name)){
                imgObj = e.target.files[0]
                imgUrl = URL.createObjectURL(e.target.files[0]);
            }
            this.setState({imgUrl:imgUrl,imgObj:imgObj});
            document.getElementById('uploadLogo').value = '';
            this.openCropModal()   
        }
        this.setState({formErrors,companyInfo,companyAddress,isLogoValid:logoValid,logoLabel:logoError});
    }

    onsearchLoc = (query) =>{
        if(query.length>=SEARCH_TEXT_COUNT){
            this.props.masterLocationListAction(query);
        }
    }

    onSelectLocation = (selected) =>{
        if(selected.length>0) {
            let selectedLoc      = selected[0];
            let companyAddress = this.state.companyAddress;
            
            companyAddress['locationId'] = selectedLoc.id;
            companyAddress['location'] = (selectedLoc.location)?selectedLoc.location:'';
            companyAddress['googleLocation'] = (selectedLoc.lat_long)?selectedLoc.lat_long:'';
            companyAddress['venue'] = (selectedLoc.venue) ? selectedLoc.venue : '';
            companyAddress['streetOne'] = (selectedLoc.street1)?selectedLoc.street1:'';
            companyAddress['streetTwo'] = (selectedLoc.street2)?selectedLoc.street2:'';
            companyAddress['city'] = (selectedLoc.city)?selectedLoc.city:'';
            companyAddress['state'] = (selectedLoc.state)?selectedLoc.state:'';
            companyAddress['country'] = (selectedLoc.country)?selectedLoc.country:'';
            companyAddress['postcode'] = (selectedLoc.postcode)?selectedLoc.postcode:'';
            this.setState({companyAddress});
            this.resetFormErrors();
        }        
        
    }

    onPhoneInputChange = (value, data, event, formattedValue) =>{
        let companyInfo  = this.state.companyInfo;
        companyInfo['companyContactNum'] = formattedValue.trim();
        
        this.setState({companyInfo});
    }

    resetFormErrors=()=>{
        let formErrors = this.state.formErrors;
    
        formErrors.companyName = '';
        formErrors.websiteUrl = '';
        formErrors.vatTax = '';
        formErrors.contactNumber = '';
        formErrors.emailAddress = '';
        formErrors.streetOne = '';
        formErrors.streetTwo = '';
        formErrors.city = '';
        formErrors.state = '';
        formErrors.country = '';
        formErrors.postcode = '';
        formErrors.timeZone = ''; 
        this.setState({formErrors});
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 4000);
        } 
    }

    validateFormData = () => {
        let companyInfo = this.state.companyInfo; 
        let companyAddress = this.state.companyAddress; 
        let formErrors = this.state.formErrors;
        let foundError = 0; 
        if(!companyInfo.companyName || companyInfo.companyName.trim().length===0) {
            formErrors.companyName = MSG_REQUIRED;
            foundError = 1;
        }

        if(companyInfo.companyEmail.length >0 && validateEmail(companyInfo.companyEmail) === false) {
            formErrors.companyEmail = MSG_REQUIRED;
            foundError = 1;
        }
        
        if(!companyInfo.timeZone || Number(companyInfo.timeZone)===0) {
            formErrors.timeZone = MSG_REQUIRED;
            foundError = 1;
        }

        if(companyInfo.vatTax.length===0 || companyInfo.vatTax.trim()==='') {
            formErrors.vatTax = MSG_REQUIRED;
            foundError = 1;
        }

        if(!companyAddress.city || companyAddress.city.trim().length===0) {
            formErrors.city = MSG_REQUIRED;
            foundError = 1;
        }
        if(!companyAddress.state || companyAddress.state.trim().length===0) {
            formErrors.state = MSG_REQUIRED;
            foundError = 1;
        }
        if(!companyAddress.country || companyAddress.country.trim().length===0) {
            formErrors.country = MSG_REQUIRED;
            foundError = 1;
        }

        this.setState({formErrors});

        if(foundError) {
            return false;
        }
        else {
            return true;
        }
    }

    openCropModal =() =>{
        this.logoModalCropper.current.handleOpenModal();
    }

    cropImage(e){
        let {imgObj,croppedAreaPixels,rotation,imgUrl} = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            'superProfile'
        )

    }
    onCropChange = crop => {
        this.setState({ crop })
    }
 
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedArea:croppedArea,croppedAreaPixels:croppedAreaPixels})
    }
 
    onZoomChange = zoom => {
        this.setState({ zoom })
    }
  
    saveFormData = (e)=>{
        e.preventDefault(); 
        this.setState({formClick:true});

        const profileId = this.state.profileId; 
        const data = new FormData(); 
        if(this.validateFormData() && this.state.isLogoValid){
            let companyInfo   = this.state.companyInfo;
            let companyAddress = this.state.companyAddress;
            let location = {}; 
            let locName = companyAddress.location; 
            if(!companyAddress.locationId || companyAddress.locationId==='') {
                locName = appendVenueLoc(companyAddress.location,companyAddress.venue); 
                location = {
                    location: locName?locName:'', 
                    venue: companyAddress.venue,
                    street1:companyAddress.streetOne, 
                    street2:companyAddress.streetTwo, 
                    city:companyAddress.city, 
                    state:companyAddress.state, 
                    country:companyAddress.country, 
                    postcode:companyAddress.postcode, 
                    lat_long:companyAddress.googleLocation?companyAddress.googleLocation:''
                };
            }
            else {
                location = {
                    id: companyAddress.locationId, 
                    location: locName?locName:'', 
                    venue: companyAddress.venue,
                    street1:companyAddress.streetOne, 
                    street2:companyAddress.streetTwo, 
                    city:companyAddress.city, 
                    state:companyAddress.state, 
                    country:companyAddress.country, 
                    postcode:companyAddress.postcode, 
                    lat_long:companyAddress.googleLocation?companyAddress.googleLocation:''
                };
            }
             
            data.append('id', profileId); 
            data.append('company_code', companyInfo.company_code);            
            data.append('company_name', companyInfo.companyName);            
            data.append('web_site', companyInfo.websiteUrl);
            data.append('phone_number', companyInfo.companyContactNum);
            data.append('company_email', companyInfo.companyEmail);
            data.append('company_reg_no', companyInfo.companyRegNum);
            data.append('vat_number', companyInfo.vatNum);
            data.append('vat', companyInfo.vatTax);
            data.append('time_zone', companyInfo.timeZone);
            data.append('is_email_disabled', companyInfo.isEmailDisabled);
            data.append('is_client_email_disabled', companyInfo.isClientEmailDisabled);
            data.append('is_crew_email_disabled', companyInfo.isCrewEmailDisabled);
            data.append('location', JSON.stringify(location)); 
            if(companyInfo.logo && companyInfo.logo!==''){ 
                data.append('logo', companyInfo.logo?companyInfo.logo:'');
            }
            this.props.updateSAProfileDetailsAction(data);    
        }
    }

    googleLocSelect = (address) =>{
        let {formErrors} = this.state; 
        let companyAddress = this.state.companyAddress; 
        let locGoogleCodes  = this.state.locGoogleCodes; 

        geocodeByAddress(address)
        .then(results => {            
            companyAddress.streetOne = ''; 
            companyAddress.streetTwo = ''; 
            companyAddress.city = ''; 
            companyAddress.state = ''; 
            companyAddress.country = ''; 
            companyAddress.postcode = '';   
            companyAddress.location = results[0].formatted_address?results[0].formatted_address:''; 
            let tmpArr = [];
            tmpArr = address.split(','); 
            companyAddress.venue = tmpArr[0]; 

            locGoogleCodes.streetOne = ''; 
            locGoogleCodes.streetTwo = ''; 
            locGoogleCodes.city = ''; 
            locGoogleCodes.state = ''; 
            locGoogleCodes.country = ''; 
            locGoogleCodes.postcode = ''; 

            let allAddress = results[0].address_components;
            let addrTypes = []; 
            let foundVar = 0; 
            let tmpVal = ''; 
            allAddress.forEach(element => {
                addrTypes = element.types;
                foundVar = 0; 
                addrTypes.forEach(item => {
                    tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '') ;
                    if(foundVar===0 && tmpVal!=='') { 
                        if(gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['streetOne'].trim()==='') companyAddress['streetOne'] = tmpVal; 
                            else companyAddress['streetOne'] += ', '+tmpVal;  

                            if(locGoogleCodes['streetOne'].trim()==='') locGoogleCodes['streetOne'] = item; 
                            else locGoogleCodes['streetOne'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['streetTwo'].trim()==='') companyAddress['streetTwo'] = tmpVal; 
                            else companyAddress['streetTwo'] += ', '+tmpVal; 
                            if(locGoogleCodes['streetTwo'].trim()==='') locGoogleCodes['streetTwo'] = item; 
                            else locGoogleCodes['streetTwo'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['city'].trim()==='') companyAddress['city'] = tmpVal; 
                            else companyAddress['city'] += ', '+tmpVal; 
                            if(locGoogleCodes['city'].trim()==='') locGoogleCodes['city'] = item; 
                            else locGoogleCodes['city'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['state'].trim()==='') companyAddress['state'] = tmpVal; 
                            else companyAddress['state'] += ', '+tmpVal; 
                            if(locGoogleCodes['state'].trim()==='') locGoogleCodes['state'] = item; 
                            else locGoogleCodes['state'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['country'].trim()==='') companyAddress['country'] = tmpVal; 
                            else companyAddress['country'] += ', '+tmpVal; 
                            if(locGoogleCodes['country'].trim()==='') locGoogleCodes['country'] = item; 
                            else locGoogleCodes['country'] += ', '+item; 
                        }
                        else if(gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                            foundVar = 1; 
                            if(companyAddress['postcode'].trim()==='') companyAddress['postcode'] = tmpVal; 
                            else companyAddress['postcode'] += ', '+tmpVal; 
                            if(locGoogleCodes['postcode'].trim()==='') locGoogleCodes['postcode'] = item; 
                            else locGoogleCodes['postcode'] += ', '+item; 
                        }
                    }
                })
            })

            getLatLng(results[0]).then(latLng=>{
                companyAddress['googleLocation'] = latLng.lat+','+latLng.lng;
            })
        }).then( () => {
            formErrors['streetOne'] = '';
            formErrors['city'] = '';
            formErrors['state'] = '';
            formErrors['country'] = '';
            formErrors['postcode'] = '';
            this.setState({companyAddress:companyAddress, locGoogleCodes:locGoogleCodes, formErrors});
        })
        .catch(error => console.error('Error', error));
    }

    onGetGoogleLoc = (e) =>{
        let resetGoogleLocation = this.state.resetGoogleLocation; 
        if(e.target.checked) {
            resetGoogleLocation++;
        }
        const {name}  = e.target;
        let companyAddress = this.state.companyAddress;        
        companyAddress[name] = e.target.checked;
        // const instance = this._typeahead.getInstance()
        // instance.clear();
        let companyAddressPrev = this.state.companyAddressPrev;   
        if(e.target.checked) {
            companyAddressPrev['locationId']     = companyAddress['locationId'];
            companyAddressPrev['venue']          = companyAddress['venue'];
            companyAddressPrev['googleLocation'] = companyAddress['googleLocation'];
            companyAddressPrev['streetOne']      = companyAddress['streetOne'];
            companyAddressPrev['streetTwo']      = companyAddress['streetTwo'];
            companyAddressPrev['city']           = companyAddress['city'];
            companyAddressPrev['state']          = companyAddress['state'];
            companyAddressPrev['country']        = companyAddress['country'];
            companyAddressPrev['postcode']       = companyAddress['postcode']; 

            companyAddress['locationId'] = '';
            companyAddress['venue'] = '';
            companyAddress['googleLocation'] = '';
            companyAddress['streetOne'] = '';
            companyAddress['streetTwo'] = '';
            companyAddress['city'] = '';
            companyAddress['state'] = '';
            companyAddress['country'] = '';
            companyAddress['postcode'] = '';  
            this.setState({companyAddress:companyAddress, companyAddressPrev:companyAddressPrev,  resetGoogleLocation}); 
        }
        else {
            companyAddress['locationId']     = companyAddressPrev['locationId'];
            companyAddress['venue']          = companyAddressPrev['venue'];
            companyAddress['googleLocation'] = companyAddressPrev['googleLocation'];
            companyAddress['streetOne']      = companyAddressPrev['streetOne'];
            companyAddress['streetTwo']      = companyAddressPrev['streetTwo'];
            companyAddress['city']           = companyAddressPrev['city'];
            companyAddress['state']          = companyAddressPrev['state'];
            companyAddress['country']        = companyAddressPrev['country'];
            companyAddress['postcode']       = companyAddressPrev['postcode']; 
            this.setState({companyAddress:companyAddress, resetGoogleLocation}); 
        }
        this.resetFormErrors(); 
    }

    componentDidUpdate(prevProps) {
        const { status, activity, errorData, timezonesListStatus, timezonesListActivity, companyInfo } = this.props;  

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            let arrResp = (activity) ? activity.split('~~') : []; 
            let actString = arrResp[0]; 

            if(actString===types.SA_PROFILE_DETAILS_SUCCESS) { 
                if(status===200) {
                    this.setState({
                        companyInfo:{
                            company_code: companyInfo.company_code, 
                            companyName:companyInfo.company_name,
                            websiteUrl:companyInfo.web_site,
                            companyContactNum:companyInfo.phone_number,
                            companyEmail:companyInfo.company_email,
                            companyRegNum:companyInfo.company_reg_no,
                            vatNum:companyInfo.vat_number,
                            vatTax:companyInfo.vat,
                            timeZone:companyInfo.region_time_zone,
                            isEmailDisabled:companyInfo.is_email_disabled,
                            isClientEmailDisabled:companyInfo.is_client_email_disabled,
                            isCrewEmailDisabled:companyInfo.is_crew_email_disabled,
                            logo:'', 
                        },
                        companyAddress:{
                            locationId:companyInfo.location.id,
                            location:companyInfo.location.location,
                            googleLocation:'',
                            venue:(companyInfo.location.venue) ? companyInfo.location.venue : '',
                            streetOne:(companyInfo.location.street1)?companyInfo.location.street1:'',
                            streetTwo:(companyInfo.location.street2)?companyInfo.location.street2:'',
                            city:(companyInfo.location.city)?companyInfo.location.city:'',
                            state:(companyInfo.location.state)?companyInfo.location.state:'',
                            country:(companyInfo.location.country)?companyInfo.location.country:'',
                            postcode:(companyInfo.location.postcode)?companyInfo.location.postcode:'',
                            noLocationFound:false,
                        },
                        imgUrl:companyInfo.logo,
                    }); 

                }
                else {
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:MSG_SERVER_DATA_FETCH_ERROR});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            }
            else if(actString===types.SA_PROFILE_DETAILS_ERROR) { 
                this.setState({toastFlag:true, toastSuccess:false, toastMessage:MSG_SERVER_DATA_FETCH_ERROR});
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }
            else if(actString===types.SA_PROFILE_DETAILS_UPDATE_SUCCESS) { 
                if(status===200) {
                    this.setState({toastFlag:true, toastSuccess:true, toastMessage:MSG_PROFILE_UPDATE_SUCCESS});
                    this.props.clearAction(); 
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
                else {
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:MSG_PROFILE_UPDATE_ERROR});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            } 
            else if(actString===types.SA_PROFILE_DETAILS_UPDATE_ERROR) { 
                this.setState({toastFlag:true, toastSuccess:false, toastMessage:MSG_PROFILE_UPDATE_ERROR});
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }
        }

        if (timezonesListActivity && (timezonesListStatus !== prevProps.timezonesListStatus || timezonesListActivity!==prevProps.timezonesListActivity)) {
            let arrResp = (timezonesListActivity) ? timezonesListActivity.split('~~') : []; 
            let actString = arrResp[0]; 
            if(actString===types.TIMEZONES_LIST_SUCCESS) { 
                if(timezonesListStatus===200) {
                    let tz = this.props.timeZonesAllItems;
                    let newTZ = tz.filter(item => item.region.trim().toLowerCase()===DEFAULT_TIME_ZONE.trim().toLowerCase()); 
                    let defTZId = 0 ;
                    if(newTZ.length) defTZId = newTZ[0].id; 
                    let companyInfo = this.state.companyInfo; 
                    if(!companyInfo.timeZone) companyInfo.timeZone = defTZId;
                    this.setState({companyInfo:companyInfo,defaultTimeZoneId:defTZId,timeZonesList:this.props.timeZonesAllItems}) 
                }
                else {
                    // timezonesListErrorData
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            } 
            else if(actString===types.TIMEZONES_LIST_ERROR) { 
                // timezonesListErrorData
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            } 
        } 
    }

    componentDidMount() {
        this.props.timeZonesListAction(); 
        if(this.state.profileId > 0){
            this.props.getSAProfileDetailsAction(this.state.profileId);       
        }
        document.title = LBL_APP_NAME+" - "+LBL_COMPANY_PROFILE;
    }

    render(){
      
        const { status,locationsList} = this.props; // currency
        const { toastMessage,toastFlag,toastSuccess, imgUrl, isLogoValid, logoLabel, formErrors, companyInfo, companyAddress, defaultTimeZoneId, timeZonesList, resetGoogleLocation } = this.state;  //profileId 
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
           return <Redirect to={ROUTE_REFRESH} />;
        }

        let logoUrl = require('../../'+URL_IMG+'affiliate-profile-new.png');
        if(imgUrl){
            logoUrl = imgUrl;
        }

        return(
            <React.Fragment>
                <div className='row' style={{width: '100%'}}>
                    <div className='margin-left-30 margin-bottom-5 padding-left-3 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                </div>
                <div className="col-md-8">

                <Form onSubmit={e => this.saveFormData(e)} encType="multipart/form-data">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <Form.Group>
                    <div className="box">
                        <div className="tab-head">
                            <h6>{LBL_COMPANY_INFO} {(companyInfo.companyName && companyInfo.companyName.length > 0) && <span>{' - '+companyInfo.companyName}</span>} </h6>
                        </div> 
                        <div className="box-content">
                             <Row>     
                                <Col md={6} className=" text-center">                                  
                                    <div className="company-logo">
                                        <img src={logoUrl} alt="Company Name" />                                                      
                                        <p className={isLogoValid?'logo-txt':'text-red logo-txt'}><small>{logoLabel}</small></p>               
                                        <label htmlFor="uploadLogo"><i className="las la-pen"></i></label>
                                        <input type="file" name="logo" onChange={(e) => this.onHandleChange(e,'companyInfo')} id="uploadLogo" />
                                    </div>
                                </Col> 
                                
                                <Col md={6}>
                                    <Row>
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_NAME}</label>
                                                <div className="text-input"><input type="text" className={formErrors.companyName.length >0 ? "input-error" : ''} onChange={(e) => this.onHandleChange(e,'companyInfo')} name="companyName" value={companyInfo.companyName || ''} maxLength={50}/>
                                                </div>
                                                {formErrors.companyName.length >0 && formErrors.companyName!==MSG_REQUIRED && (
                                                    <div className="text-red left-align text-12">{formErrors.companyName}</div>
                                                )} 
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_CONTACT_NUM}</label>
                                                <PhoneInput 
                                                  country={PHONE_ISD_CODE}
                                                  inputProps={{
                                                    name: 'companyContactNum',
                                                  }}
                                                  value={companyInfo.companyContactNum || PHONE_ISD_NUM}
                                                  onChange={this.onPhoneInputChange} 
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>  
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_REG_NUM}</label>
                                                <div className="input-input"><input type="text" onChange={(e) => this.onHandleChange(e,'companyInfo')} name="companyRegNum" value={companyInfo.companyRegNum || ''} /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>                
                            </Row>
                            
                            <Row> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_COMPANY_EMAIL}</label>
                                        <div className="input email-input"><input type="email" onChange={(e) => this.onHandleChange(e,'companyInfo')} name="companyEmail" value={companyInfo.companyEmail || ''} maxLength={120} className={formErrors.companyEmail.length >0 ? "input-error" : ''} /></div>
                                    </div>
                                </Col>
                                <Col md={6}> 
                                    <div className="form-group">
                                        <label>{LBL_WEBSITE}</label>
                                        <div className="input weburl-input">
                                            <input type="text" onChange={(e) => this.onHandleChange(e,'companyInfo')} name="websiteUrl" value={companyInfo.websiteUrl || ''} maxLength={120} autoComplete="off" />
                                        </div>
                                        {formErrors.websiteUrl.length >0 && (
                                            <div className="text-red left-align text-12">{formErrors.websiteUrl}</div>
                                        )} 
                                    </div>
                                </Col>
                            </Row>
                            <Row> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VAT_NUMBER}</label>
                                        <div className="input-input"><input type="text" onChange={(e) => this.onHandleChange(e,'companyInfo')} name="vatNum" value={companyInfo.vatNum || ''} /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VAT_TAX}</label>
                                        <div className="input-input"><input type="text" onChange={(e) => this.onHandleChange(e,'companyInfo')} name="vatTax" value={companyInfo.vatTax || ''} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} autoComplete="off" className={formErrors.vatTax.length >0 ? "input-error" : ''} /></div>
                                    </div>
                                </Col>
                            </Row>
                            
                            <Row>                                
                                <Col md={6}>
                                    <div className="form-group"> 
                                        <label>{LBL_TIME_ZONE} </label> 
                                        <div className="form-group select-input">
                                            <select name="timeZone" onChange={(e) => this.onHandleChange(e,'companyInfo')} value={companyInfo.timeZone ? companyInfo.timeZone : (defaultTimeZoneId ? defaultTimeZoneId : "")} >
                                                <option value=''>{LBL_SELECT_TIME_ZONE}</option>
                                                {timeZonesList.map((item) => <option key={item.id} value={item.id}>{item.region}</option>)}  
                                                {/* - UTC'+item.offset */}
                                            </select>
                                        </div>
                                    </div>
                                </Col>
                            </Row>





                            <Row> 
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{LBL_LOCATION}</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="custom-checkbox">
                                            <input type="checkbox" id="noLocationFound" name="noLocationFound" onChange={this.onGetGoogleLocClick} checked={companyAddress.noLocationFound} />
                                            <label className="checkbox" htmlFor="noLocationFound"></label>
                                            <label className="labeltext" htmlFor="noLocationFound">{LBL_LOC_GET_GOOGLE}
                                                <sup>
                                                <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderTooltip(LBL_TYPE_ADDRESS_GOOGLE)}
                                                >
                                                <button type="button" className="tootltip-btn">
                                                <i className="las la-question-circle"></i>
                                                </button>
                                                </OverlayTrigger>
                                                </sup>
                                            </label>
                                        </div>
                                    </div>
                                </div>    
                                            
                                <div className="col-md-12">                           
                                    <div className="form-group">
                                        <div className={companyAddress.noLocationFound?'hide':'text-input'} >
                                            <AsyncTypeahead
                                                isLoading={false}
                                                name="location" 
                                                id="locationSearch"
                                                minLength={3}
                                                labelKey="location"
                                                onChange={selected => this.onSelectLocation(selected)}
                                                options={locationsList}
                                                placeholder={LBL_TYPE_A_LOCATION}
                                                onSearch={this.onsearchLoc}
                                                searchText={LBL_SEARCHING} 
                                                promptText={LBL_TYPE_A_LOCATION}
                                                disabled={this.disableLocationSearch}
                                                ref={(ref) => this._typeahead = ref}
                                            />  

                                        </div>
                                        <div className={companyAddress.noLocationFound?'text-input':'hide'} >
                                            <LocationSearchInput name="googleLocation" googleLocSelect={this.googleLocSelect} disabled={this.disableLocationSearch} resetGoogleLocation={resetGoogleLocation} />
                                        </div>  
                                    </div>
                                </div>
                            </Row>
                            
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VENUE_PROFILE}</label>
                                        <div className="text-input ">
                                            <input type="text" placeholder={LBL_VENUE_PROFILE} name="venue" onChange={(e) => this.onHandleChange(e,'addressInfo')} value={companyAddress.venue || ''} maxLength={125}/>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">&nbsp;</div>
                                </Col>
                            </Row>
                            
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STREET_1}</label>
                                        <div className="text-input "><input type="text" name="streetOne" onChange={(e) => this.onHandleChange(e,'addressInfo')}  value={companyAddress.streetOne || ''} maxLength={50}  /></div>
                                    </div>
                                </Col> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STREET_2}</label>
                                        <div className="text-input "><input type="text" name="streetTwo" onChange={(e) => this.onHandleChange(e,'addressInfo')}  value={companyAddress.streetTwo || ''} maxLength={50}  /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_CITY}</label>
                                        <div className="text-input "><input type="text" name="city" onChange={(e) => this.onHandleChange(e,'addressInfo')} className={formErrors.city.length >0 ? "input-error" : ''} value={companyAddress.city || ''} maxLength={50}  /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STATE}</label>
                                        <div className="text-input "><input type="text" name="state" onChange={(e) => this.onHandleChange(e,'addressInfo')} className={formErrors.state.length >0 ? "input-error" : ''} value={companyAddress.state || ''} maxLength={50}  /></div>
                                    </div>
                                </Col>
                            </Row>
                             
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_COUNTRY}</label>
                                        <div className="text-input "><input type="text" name="country" onChange={(e) => this.onHandleChange(e,'addressInfo')} className={formErrors.country.length >0 ? "input-error" : ''} value={companyAddress.country || ''} maxLength={50}  /></div>
                                    </div> 
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_POST_CODE}</label>
                                        <div className="text-input "><input type="text" name="postcode" onChange={(e) => this.onHandleChange(e,'addressInfo')} className={formErrors.postcode.length >0 ? "input-error" : ''} value={companyAddress.postcode || ''} maxLength={10}  /></div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>  
                                <Col className={"block-email"} md={10}>
                                    <div className="form-group width-auto">
                                        <label htmlFor=""></label>
                                            <div className="custom-checkbox float-right"><input name="isEmailDisabled" type="checkbox" id="check2" checked={companyInfo.isEmailDisabled} onChange={(e) => this.onHandleChange(e,'companyInfo')}/><label className="checkbox" htmlFor="check2"></label><label className="labeltext" htmlFor="check2">{'Block all affiliate emails'}</label></div>                                   
                                    </div>
                               
                               
                                    <div className="form-group width-auto">
                                        <label htmlFor=""></label>
                                            <div className="custom-checkbox float-right"><input name="isClientEmailDisabled" type="checkbox" id="check3" checked={companyInfo.isClientEmailDisabled} onChange={(e) => this.onHandleChange(e,'companyInfo')}/><label className="checkbox" htmlFor="check3"></label><label className="labeltext" htmlFor="check3">{"Block all client emails"}</label></div>                                   
                                    </div>
                               
                                
                                    <div className="form-group width-auto">
                                        <label htmlFor=""></label>
                                            <div className="custom-checkbox float-right"><input name="isCrewEmailDisabled" type="checkbox" id="check4" checked={companyInfo.isCrewEmailDisabled} onChange={(e) => this.onHandleChange(e,'companyInfo')}/><label className="checkbox" htmlFor="check4"></label><label className="labeltext" htmlFor="check4">{'Block all staff emails'}</label></div>                                   
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-primary float-right">{LBL_SAVE}</button>
                                    </div>
                                </Col>
                            </Row> 
                        </div>
                    </div>
                </Form.Group>  
            </Form>      
            </div> 
            <ModalWindow ref={this.logoModalCropper} type="imageCropper" saveFormData={ (e)=>this.cropImage(e)}>
                    <Cropper
                        image={this.state.imgUrl}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                      />
                </ModalWindow>     
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => { 
    return {
        companyInfo:state.superAdmin.companyInfo,
        status:state.superAdmin.status,
        activity:state.superAdmin.activity,
        locationsList:state.affiliates.locations,
        errorData:state.superAdmin.errorData,
        timeZonesAllItems:state.timeZones.timezonesList,
        timezonesListStatus:state.timeZones.timezonesListStatus,
        timezonesListActivity:state.timeZones.timezonesListActivity,
        timezonesListErrorData:state.timeZones.timezonesListErrorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getSAProfileDetailsAction:getSAProfileDetailsAction,
        updateSAProfileDetailsAction:updateSAProfileDetailsAction,
        clearAction:clearAction,
        timeZonesListAction:timeZonesListAction,
        masterLocationListAction:data=>masterLocationListAction(data),
    },dispatch);
}     

export default connect(mapStateToProps,mapDispatchToProps)(SAProfileComponent);
